<template>
	<div>
		<a-modal v-show='!ishand' id='supp_bank' width='45rem' v-model="visible" on-ok="handleOk1"
			:dialog-style="{ top:'5vh' }" v-dragModal
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div  v-html='items?"编&nbsp;&nbsp;&nbsp;&nbsp;辑":"添&nbsp;&nbsp;&nbsp;&nbsp;加"'
					style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 43rem;margin: 1rem 1rem 0 1rem;text-align: center;">
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="paddingBottom: 1rem;border-radius: 0 0 10px 10px;padding: 1rem;background-color: #fff;
			width: 43rem;margin: 0 auto;marginBottom: 1rem;">
				<div style="padding-top: 1.5rem;position: relative;left: 0rem;">
					<div class="yhxx_class">
						<div></div>
						銀行信息
					</div>
					<a-form-model ref='form' :model="form" labelAlign='left' layout="inline" :rules='rules'
						hideRequiredMark style='max-height: 35rem;overflow-y: auto;'>
						<a-row type='flex' justify='space-around'>
							<a-col :span='11'>
								<a-form-model-item label='受款帳戶中文'>
									<!--  prop='accountname_cn' -->
									<a-input v-model="form.accountname_cn" class='warp_width' @input='getdata' placeholder='請輸入受款帳戶中文'
									/>
								</a-form-model-item>
							</a-col>
							<a-col :span='11'>
								<a-form-model-item label='受款帳戶英文' prop='accountname_en'>
									<a-input v-model="form.accountname_en" class='warp_width' placeholder='請輸入受款帳戶英文'
									@input="form.accountname_en=form.accountname_en.replace(/[^a-z A-Z 0-9 %&',;=?$x22]/g,'')"/>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row type='flex' justify='space-around'>
							<a-col :span='11'>
								<a-form-model-item label='收款銀行中文' prop='bankname_cn'>
									<a-input v-model="form.bankname_cn" class='warp_width' @input='getdata' placeholder='請輸入收款銀行中文'
									 />
								</a-form-model-item>
							</a-col>
							<a-col :span='11'>
								<a-form-model-item label='收款銀行英文' prop='bankname_en'>
									<a-input v-model="form.bankname_en" class='warp_width' placeholder='請輸入收款銀行英文'
									@input="form.bankname_en=form.bankname_en.replace(/[^a-z A-Z 0-9 %&',;=?$x22]/g,'')"/>
								</a-form-model-item>
							</a-col>
						</a-row>
						
						<a-row >
							<a-col :span='24'>
								<div class='div_input'>
									<a-form-model-item label='銀行地址中文' prop='address_cn'>
										<a-input v-model="form.address_cn" class='warp_width' @input='getdata' placeholder='請輸入銀行地址中文'
										/>
									</a-form-model-item>
								</div>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span='24'>
								<div  class='div_input'>
								<a-form-model-item label='銀行地址英文' prop='address_en'>
									<a-input v-model="form.address_en" class='warp_width'  placeholder='請輸入銀行地址英文'
									@input="form.address_en=form.address_en.replace(/[^a-z A-Z 0-9 %&',.;=?*()--/#@{}$x22]/g,'')"/>
								</a-form-model-item></div>
							</a-col>
						</a-row>
						<a-row type='flex' justify='space-around' v-for='(val,i) in form.accountnumberList' :key='i+"1025"'>
							<a-col :span='11'>
								<!-- getparas -->
								<a-form-model-item label='貨幣種類' prop='mobile_type'>
									<!-- <a-input v-model="val.ccytype" class='warp_width' /> -->
									<Situationall v-model="val.ccytype" :url='$api.getparas' ref='seachope'
										:params='{"type":"bankinfoccytype"}' :style='"width:100%"' :placeholder="'請選擇貨幣幣種'">
									</Situationall>
								</a-form-model-item>
							</a-col>
							<a-col :span='11' style='text-align: right;'>
								<a-form-model-item label='貨幣帳號' prop='mobileservice'>
									<!-- style='width: 70%; position: relative; top:.2rem;' -->
									<!-- <a-input-search v-model="val.account_number" class='warp_width' @input='getdata'
									 placeholder='' @search="handpush(i)" >
									 <div slot="enterButton">
										 <img :src="require('@/image/new/add.png')" alt="" style="width: .8rem;" >
									</div>
									</a-input-search> -->
								<!-- <a-button slot="enterButton">
								  {{i?'x':'+'}}</a-button> -->
								 <a-input v-model="val.account_number" class='warp_width'
								 placeholder='' >
								 <a-tooltip slot="suffix" title="Extra information" @click="handpush(i)">
								        <!-- <img :src="require('@/image/new/add.png')" alt="" style="width: .8rem;"> -->
										<a-icon :type="i?'close':'plus'" />
								       </a-tooltip>
									   </a-input>
								<!-- </a-input-search> -->
								</a-form-model-item>
							</a-col>
						</a-row>
						
						<a-row type='flex' justify='space-around'>
							<a-col :span='11'>
								<a-form-model-item label='國際區貸款號' prop='swift_code'>
									<a-input v-model="form.swift_code" class='warp_width' @input='getdata' placeholder='請輸入國際區貸款號'/>
								</a-form-model-item>
							</a-col>
							<a-col :span='11'></a-col>
						</a-row>
						<!-- <div id='lastname'>
							<a-form-model-item prop='supplier'>
								<div slot='label' v-html='"供&nbsp;&nbsp;應&nbsp;商"'
								 style="display: inline-block;color: #000000;"></div>
								<a-input v-model="form.supplier" style='width: 30.5rem;height: 35px !important;'/>
							</a-form-model-item>
							<a-form-model-item prop='remark'>
								<div slot='label' v-html='"備&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;註"'
								 style="display: inline-block;color: #000000;"></div>
								<a-textarea v-model="form.remark" placeholder=" " :auto-size="{ minRows: 3, maxRows: 5 }"
									style='width: 30.5rem;' />
							</a-form-model-item>
						</div> -->
						<!-- 123123 -->
						<div class="yhxx_class">
							<div></div>
							銀行聯絡人
						</div>
						<a-row type='flex' justify='space-around'>
							<a-col :span='11'>
								<a-form-model-item label='聯絡名稱' prop='contact_person'>
									<a-input v-model="form.contact_person" class='warp_width' @input='getdata' placeholder='請輸入聯絡名稱'/>
								</a-form-model-item>
							</a-col>
							<a-col :span='11'>
								<a-form-model-item label='電話號碼' prop='contact_person_phone'>
									<a-input v-model="form.contact_person_phone" class='warp_width' placeholder='請輸入電話號碼'
									@input="form.contact_person_phone = form.contact_person_phone.replace(/[^0-9 %&',;=?$x22]/g,'')"/>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row type='flex' justify='space-around'>
							<a-col :span='11'>
								<a-form-model-item label='電子郵箱' prop='contact_person_email'>
									<a-input v-model="form.contact_person_email" @blur='emailfn()' class='warp_width' @input='getdata' placeholder='請輸入電子郵箱'/>
								</a-form-model-item>
							</a-col>
							<a-col :span='11'></a-col>
						</a-row>
						<a-row>
							<a-col :span='24'>
								<div  class='div_input'>
								<a-form-model-item label='備註' >
									<a-input v-model="form.remark" class='warp_width'  placeholder='請輸入備註'/>
								</a-form-model-item></div>
							</a-col>
						</a-row>
					</a-form-model>
				
					<div style="text-align: center;">
						<button class='btn1 btnx' @click='handbect("form")' v-html='"保&nbsp;&nbsp;&nbsp;&nbsp;存"'>保存</button>
						<!-- <button class='btn1 btn2' @click='resetForm("form")'>清除</button> -->
					</div>
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		props: ['items'],
		data() {
			return {
				ishand: false,
				visible: true,
				rules: {
					bankname_cn:[{required:true,message:' ',trigger:'blur'}],
					bankname_en:[{required:true,message:' ',trigger:'blur'}],
					accountname_cn:[{required:true,message:' ',trigger:'blur'}],
					accountname_en:[{required:true,message:' ',trigger:'blur'}],
					address_cn:[{required:true,message:' ',trigger:'blur'}],
					address_en:[{required:true,message:' ',trigger:'blur'}],
					swift_code:[{required:true,message:' ',trigger:'blur'}],

					contact_person:[{required:true,message:' ',trigger:'blur'}],
					contact_person_phone:[{required:true,message:' ',trigger:'blur'}],
					contact_person_email:[{required:true,message:' ',trigger:'blur'}],
					// remark:[{required:true,message:' ',trigger:'blur'}],
					// register_date:[{required:true,message:' ',trigger:'change'}],
					// expire_date:[{required:true,message:' ',trigger:'change'}],
				},
				form: {
					 "bankname_cn":"",
					 "bankname_en":"",
					 "accountname_cn":"",
					 "accountname_en":"",
					 "address_cn":"",
					 "address_en":"",
					 "swift_code":"",
					 "contact_person":"",
					 "contact_person_phone":"",
					 "contact_person_email":"",
					 "remark":"",
					 "token":"",
					 "accountnumberList":[
					  {
					   "account_number":"",
					   "ccytype":""
					  }
					 ]
				},
			}
		},
		mounted() {
			if(this.items){
				this.handz()
			}
		},
		methods: {
			emailfn() {
				if (this.form.contact_person_email) {
					var t = /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/;
					if (!(t.test(this.form.contact_person_email))) {
						this.form.contact_person_email = ''
						this.$message.warning('請輸入正確的電郵地址')
					}
				}
			},
			handpush(i){
					if(i){
						this.form.accountnumberList.splice(i,1)
					}else{
						// if(this.form.accountnumberList.length===1){
							this.form.accountnumberList.push({"account_number":"","ccytype":""})
						// }
					}
			},
			getdata() {

			},
			//获取美国 香港当地时间
			handz(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.ditodate,
					data: {
						"flag":"mobileservice",
						 "mobileserviceid":this.items
					}
				}).then(res => {
					if (res.data) {
						this.form = res.data
						// App.oTool.successT();
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				// this.handz()
			},
			//下单
			handbect(ruleForm) {
				 this.$refs[ruleForm].validate(valid => {
				        if (valid) {
							this.form.token = this.$store.state.token;
							this.form.flag = "mobileservice";
							this.$ajax({
								method: 'post',
								url: this.$api.newBankInfo,
								data: this.form
							}).then(res => {
								if (res.data.qmiscode === 1000) {
									App.oTool.successT();
									this.$emit('child', 1)
								} else {
									App.oTool.warningT(res.data.qmismsg);
								}
							})
				        } else {
				          console.log('error submit!!');
				          return false;
				        }
				      });
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			}
		}
	}
</script>

<style lang="scss">
	.yhxx_class{
		font-size: 0.9rem;
		font-weight: 600;
		display: flex;
		align-items: center;
		margin-bottom: 0.5rem;
	}
	.yhxx_class div{
		width: 3px;
		height: 18px;
		background-color: #0c8b97;
		margin-right: 8px;
	}
	#supp_bank .ant-modal-header,
	#supp_bank .ant-modal-body {
		background-color: #e5e5e5 !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}

	.mark-file {
		position: absolute;
		top: 0;
		left: 0;

		div {
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	.mark-file1 {
		position: absolute;
		top: 0;
		left: 0;
		width: 19rem;

		div {
			font-size: 1rem;
			padding: .5rem 1rem;
			background-color: #0c8b97;
			border-radius: 10px 10px 0 0;
			color: #fff;
			text-align: center;
		}
	}

	#supp_bank {
		.ant-form-explain{
			display: none;
		}
		.ant-modal {
			top: 25vh;
		}

		.ant-col-12 {
			text-align: right;
		}

		.ant-form-item-label {
			width: 30%;
		}
		.ant-form-item, .ant-form-item-control{
			width: 100%;
			.ant-calendar-picker{
				width: 100%;
			}
			
		}
		
		.ant-form-item-control-wrapper{
			width:70%;
			.ant-form-item-control{
				width: 100%;
			}
		}
		.div_input{
			.ant-form-item-label {
				width: 14%;
				margin-left: 2%;
			}
			.ant-form-item-control-wrapper{
				width:82%;
				.ant-form-item-control{
					width: 100%;
				}
			}
		}
		#lastname>div{
			// justify-content: flex-end;
			text-align: right;
			}
		#lastname{
			.ant-form-item-label{
				width: 10%;
			}
			.ant-form-item-control-wrapper{
				width: 86%;
				    // left: .3rem;
				    position: relative;
			}
		}
		.ant-form-inline .ant-form-item {
			margin-right: 0;
		}

		.warp-right {
			text-align: right;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: .8rem !important;
		}

		.ant-input {
			font-size: .8rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: .8rem !important;
		}

		.ant-form-item-children {
			font-size: .8rem !important;
		}

		.mydivs {
			max-height: 11rem;
			overflow-y: auto;
			// margin-bottom: 1rem;
			padding: 1rem;
			margin-left: 4%;
			width: 96%;
			background-color: #f5f5f5;
			margin-bottom: 1rem;
		
			.c {
				font-size: .8rem;
				margin: .2rem 0;
			}
		
			.f {
				// display: flex;
				// justify-content: space-between;
				position: relative;
				right: 0;
				top: 0;
			}
		
			.t {
				margin: .5rem 0;
				border-bottom: 1px solid #d9d9d9;
			}
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 8rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3rem;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #999999;
		}
	}
</style>
